import { Breadcrumb } from 'antd';
import React from 'react';

const MediaAddress: React.FC = () => (
  <Breadcrumb style={{ marginTop: '18px', fontSize: '16px', marginBottom: '10px' }} separator=">">
    <Breadcrumb.Item> {localStorage.getItem("i18nextLng") === 'zh-HK' ? '主頁' : '主页'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '新聞中心' : '新闻中心'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '傳媒報道' : '传媒报道'}</Breadcrumb.Item>
  </Breadcrumb>
);

export default MediaAddress;